

























import VirtualList from 'vue-virtual-scroll-list';
import { IdentityInfo, IdentityOptionList } from '@tt4b/ttam-enums';
import { defineComponent, ref, computed, toRefs, onUnmounted, PropType } from '@vue/composition-api';
import { useIdentityPageList } from '../hooks/use-identity-page-list';
import ListItem from './list-item.vue';
import { createLogger } from '@tt4b/ttam-utils';

const logger = createLogger('CreativeIdentityList');

const name = 'ttam-common-tiktok-list';
export default defineComponent({
  name,
  components: {
    VirtualList,
  },
  props: {
    isSupportBCNvN: {
      type: Boolean,
      default: false,
    },
    activeData: {
      type: Object as PropType<IdentityInfo>,
      default: () => ({
        displayName: '',
        avatarIcon: {
          width: 20,
          height: 20,
          webUri: '',
          url: '',
        },
        identityId: '',
        identityBcId: '',
      }),
    },
    type: {
      type: Number,
      default: 2,
    },
    listData: {
      type: Object,
      default: () => ({
        list: [],
        page: 1,
        hasMore: true,
        cursor: 0,
      }),
    },
    genListOptionsFunction: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { listData, type, isSupportBCNvN } = toRefs(props);

    /** 列表 start */
    const dataList = ref<IdentityOptionList[] & IdentityInfo[]>([]);

    const { page, hasMore, loading, cursor, handleLoad, resetPageList } = useIdentityPageList({
      identityType: type.value,
      identityAuthId: '',
      identityBcId: '',
      genListOptionsFunction: props.genListOptionsFunction,
    });

    const baList = computed(() => listData.value?.ttbaList || []);
    const bcList = computed(() => listData.value?.ttbcList || []);

    // 默认值（传过来的第一页数据）
    if (isSupportBCNvN.value) {
      dataList.value = [
        {
          bannerType: 'TTBA',
          isEmpty: !baList.value?.length,
          id: 'banner_ttba',
        },
        ...baList.value,
        {
          bannerType: 'TTBC',
          isEmpty: !bcList.value?.length,
          id: 'banner_ttbc',
        },
        ...bcList.value,
      ];
    } else {
      dataList.value = listData.value?.list;
    }
    page.value = listData.value?.page;
    hasMore.value = listData.value?.hasMore;
    cursor.value = listData.value?.cursor;

    const isListEmpty = computed(() => !dataList.value?.length);

    const onScrollBottom = () => {
      logger.info('list onScrollBottom: page = %s hasmore = %s', page.value, hasMore.value);
      if (loading.value) {
        return;
      }

      if (hasMore.value) {
        page.value += 1;
        logger.info('list onScrollBottom and load next page');
        handleLoad().then((data = []) => {
          dataList.value = dataList.value.concat(data);
          logger.info('list onScrollBottom and load next page success');
        });
      }
    };

    const onAuthorizeBA = () => {
      emit('authorizeBA');
    };

    const onClick = (val: IdentityOptionList) => {
      emit('click', val);
    };

    const onPopoverCTA = (val: IdentityOptionList) => {
      emit('popover-click', val);
    };
    /** 列表 end */

    onUnmounted(() => {
      resetPageList();
    });

    return {
      name,
      isListEmpty,
      dataList,
      loading,
      hasMore,
      page,
      onScrollBottom,

      ListItem,

      onClick,
      onPopoverCTA,
      onAuthorizeBA,
    };
  },
});
